import { PictureProps } from "../../interface";

/**
 * This component renders an image. It can accept an array of media breakpoints and image
 * srcset, and render different image sources at different breakpoints
 * @param refer to PictureProps interface for a full list of params
 * @returns Picture component
 */
const Picture = ({ classNames, sources, url, alt, loading }: PictureProps) => {
    return (
        <picture className={classNames}>
            {sources?.map((source, index) => {
                return (
                    <source
                        key={index}
                        media={source.media}
                        srcSet={source.srcset}
                    />
                );
            })}
            <img
                src={url}
                alt={alt || ""}
                loading={loading === "lazy" ? "lazy" : "eager"}
            />
        </picture>
    );
};

export default Picture;
